export const SUBSCRIBED_ROOM_MESSAGES = 'SUBSCRIBED_ROOM_MESSAGES';
export const RECEIVE_NEW_ROOM_MESSAGE = 'RECEIVE_NEW_ROOM_MESSAGE';
export const RECEIVE_UPDATE_ROOM_MESSAGE = 'RECEIVE_UPDATE_ROOM_MESSAGE';
export const RECEIVE_DELETE_ROOM_MESSAGE = 'RECEIVE_DELETE_ROOM_MESSAGE';
export const RECEIVE_ROOM_MESSAGES = 'RECEIVE_ROOM_MESSAGES';
export const REQUEST_SEND_MESSAGE = 'REQUEST_SEND_MESSAGE';
export const RECEIVE_SEND_ERROR_MESSAGE = 'RECEIVE_SEND_ERROR_MESSAGE';
export const DELETE_ROOM_MESSAGES = 'DELETE_ROOM_MESSAGES';
